export default function initInfoPopup() {
    const modal = document.getElementById('informational-popup');
    const informationPopupAccept = document.querySelector('.information-popup-accept');

    if (modal && informationPopupAccept) {
        informationPopupAccept.addEventListener('click', () => {
            const type = 'consents_information_popup' + informationPopupAccept.dataset.infoVersion;
            const d = new Date();
            d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toGMTString();
            document.cookie = type + "=1;" + expires + ";path=/";
            window.hideModal(modal);
        });

        window.showModal(modal);
    }
}
